import * as tslib_1 from "tslib";
import { constants } from 'src/helpers/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class TenantHomeService {
    constructor(http) {
        this.http = http;
    }
    getHomeViewModel() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.http.get(constants.url_constants.api + '/api/TenantsApi/GetHomeViewModel').toPromise();
        });
    }
    getCourseEnquiryModel(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.http.get(constants.url_constants.api + '/api/TenantsApi/GetCourseEnquiryModel?courseId=' + id).toPromise();
        });
    }
    saveEnquiry(enquiryModel) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.http.post(constants.url_constants.api + '/api/EnquiryApi/SaveEnquiry', enquiryModel).toPromise();
        });
    }
}
TenantHomeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TenantHomeService_Factory() { return new TenantHomeService(i0.ɵɵinject(i1.HttpClient)); }, token: TenantHomeService, providedIn: "root" });
